import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'

import { GeoLogoMiniComponent } from './geo-logo-mini/geo-logo-mini.component'
import { SelectfilterComponent } from './selectfilter/selectfilter.component'
import { ValueSwitcherComponent } from './value-switcher/value-switcher.component'
import { LoadingComponent } from './loading/loading.component'
import { ToggleComponent } from './toggle/toggle.component'

import { TranslateModule } from '@ngx-translate/core'

const components = [
  GeoLogoMiniComponent,
  SelectfilterComponent,
  ValueSwitcherComponent,
  LoadingComponent,
  ToggleComponent,
]

@NgModule({
  imports: [CommonModule, FormsModule, TranslateModule],
  declarations: [...components],
  exports: [...components],
})
export class LatitudeAltModule {}
